"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ReportFunnelIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5C16.2761 5 16.5 5.22386 16.5 5.5V6.57746C16.5 6.8536 16.2761 7.07746 16 7.07746L4 7.07746C3.72386 7.07746 3.5 6.8536 3.5 6.57746L3.5 5.5C3.5 5.22386 3.72386 5 4 5H16ZM13.8334 8.87793C14.1095 8.87793 14.3334 9.10179 14.3334 9.37793V10.4554C14.3334 10.7315 14.1095 10.9554 13.8334 10.9554H6.16674C5.8906 10.9554 5.66674 10.7315 5.66674 10.4554V9.37793C5.66674 9.10179 5.8906 8.87793 6.16674 8.87793L13.8334 8.87793ZM12.1667 13.2557C12.1667 12.9796 11.9428 12.7557 11.6667 12.7557H8.33335C8.05721 12.7557 7.83335 12.9796 7.83335 13.2557V14.3332C7.83335 14.6093 8.05721 14.8332 8.33335 14.8332H11.6667C11.9428 14.8332 12.1667 14.6093 12.1667 14.3332V13.2557Z"
  }));
}
var defaultProps = {
  color: _constants.colors.mediumGrey,
  size: 20
};
ReportFunnelIcon.defaultProps = defaultProps;
var _default = exports["default"] = ReportFunnelIcon;